/*!
 * devextreme-vue
 * Version: 20.2.6
 * Build date: Tue Mar 16 2021
 *
 * Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-vue
 */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVue3 = exports.getVueVersion = void 0;
var VueType = require("vue");
var Vue = VueType.default || VueType;
function getVueVersion() {
    var currentVersion = Vue.version;
    return Number(currentVersion.split(".")[0]);
}
exports.getVueVersion = getVueVersion;
function isVue3() {
    return getVueVersion() === 3;
}
exports.isVue3 = isVue3;
